export default __webpack_public_path__ + "static/media/1517.2ed951b2.svg";